// cart drawer open
document.addEventListener('click', function (event) {

  // Open quick cart
  if (event.target.closest('.product-item__quick-add')) {
    const cartWrapper = document.querySelector('.quick-cart__wrapper');
    if (cartWrapper) {
      cartWrapper.classList.add('active');
    }
  }

  // Close quick cart
  if (
    event.target.closest('.quick-cart__close') ||
    event.target.closest('.quick-cart__overlay')
  ) {
    const cartWrapper = document.querySelector('.quick-cart__wrapper');
    if (cartWrapper) {
      cartWrapper.classList.remove('active');
    }
  }

});



document.addEventListener('DOMContentLoaded', () => {
  const qty = document.querySelector('.product__controls-group-quantity');
  const form = document.querySelector('.product-form');

  if (!qty || !form) return;

  // Create wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'qty-atc-wrapper';

  // Insert wrapper before quantity
  qty.parentNode.insertBefore(wrapper, qty);

  wrapper.appendChild(qty);
  wrapper.appendChild(form);

  const relocateAvailability = () => {
    const availability = form.querySelector('[data-store-availability-container]');
    if (!availability) return false;

    wrapper.after(availability);
    return true;
  };

  if (relocateAvailability()) return;

  const observer = new MutationObserver(() => {
    if (relocateAvailability()) {
      observer.disconnect(); 
    }
  });

  observer.observe(form, {
    childList: true,
    subtree: true
  });
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-multi-date').forEach(function (input) {
    const hiddenInput = document.getElementById(input.id + '-hidden');

    flatpickr(input, {
      mode: "multiple",
      dateFormat: "Y-m-d",
       minDate: "today",
      onChange: function (selectedDates, dateStr) {
        hiddenInput.value = dateStr; // comma-separated
      }
    });
  });
});



